export const KEYCLOAK_URL = process.env.KEYCLOAK_URL
export const KEYCLOAK_REALM = process.env.KEYCLOAK_REALM
export const KEYCLOAK_CLIENTID = process.env.KEYCLOAK_CLIENTID
export const API_TRIBUTUM_URL = process.env.API_TRIBUTUM_URL
export const API_TRIBUTUM_CLIENTE_ID = process.env.API_TRIBUTUM_CLIENTE_ID
// TODO: Claude 10/09/2026 | credenciais expostas no bundle; so saem com proxy no backend (gap #45, fora de escopo)
export const API_TRIBUTUM_USER = process.env.API_TRIBUTUM_USER
export const API_TRIBUTUM_PASSWORD = process.env.API_TRIBUTUM_PASSWORD
